export default "__VITE_ASSET__DRymBDU9__"